module.exports = {
  'Never Expires': null,
  '30 days': 30,
  '45 days': 45,
  '60 days': 60,
  '90 days': 90,
  '120 days': 120,
  '160 days': 160,
};
